// components/Login.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useSeasonalTheme } from '../context/SeasonalThemeContext';
import NightModeToggle from './NightModeToggle';
import SeasonalBackground from './SeasonalBackground';
import { usePerfMode } from '../utils/perfMode';
import './Login.css';

const Login = () => {
  const perfMode = usePerfMode();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const { login } = useAuth();
  const { activeTheme } = useSeasonalTheme();
  const loginLogoLight = activeTheme?.login_logo_light || '/icons/basket (3).png';
  const loginLogoDark = activeTheme?.login_logo_dark || '/icons/basket (4).png';
  const hasSunflowers = activeTheme?.login_bg_light === 'sunflowers';
  const hasYellowLights = activeTheme?.login_bg_dark === 'yellow_lights';
  const hasHalloweenDay = activeTheme?.login_bg_light === 'halloween_day';
  const hasHalloweenNight = activeTheme?.login_bg_dark === 'halloween_night';

  const containerClassName = [
    'login-container',
    hasSunflowers && 'login-style-sunflowers',
    hasYellowLights && 'login-style-yellow-lights',
    hasHalloweenDay && 'login-style-halloween-day',
    hasHalloweenNight && 'login-style-halloween-night',
  ].filter(Boolean).join(' ');

  const navigate = useNavigate();
  const location = useLocation();

  const from = location.state?.from?.pathname || '/';

  // the login is laid out for phones: use the device's width while it is open (the app's pages set their own after)
  useEffect(() => {
    const meta = document.querySelector('meta[name="viewport"]');
    if (!meta) return undefined;
    const before = meta.getAttribute('content');
    meta.setAttribute('content', 'width=device-width, initial-scale=1');
    return () => meta.setAttribute('content', before || 'width=1280');
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(username, password);

    if (result.success) {
      navigate(from, { replace: true });
    } else {
      setError(result.error);
    }

    setLoading(false);
  };

  return (
    <div className={containerClassName}>
      {perfMode === 'full' && <SeasonalBackground />}
      <form className="login-form" onSubmit={handleSubmit}>
        <div className="login-header">
          <img
            src={loginLogoLight}
            alt="PF Login"
            className="login-icon login-icon--light"
            onError={e => e.target.style.display = 'none'}
          />
          <img
            src={loginLogoDark}
            alt="PF Login"
            className="login-icon login-icon--dark"
            onError={e => e.target.style.display = 'none'}
          />
        </div>

        {error && <div className="error-message">{error}</div>}

        <div className="form-group">
          <label htmlFor="username">Usuario:</label>
          <input
            type="text"
            id="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            autoComplete="username"
          />
        </div>

        <div className="form-group">
          <label htmlFor="password">Contraseña:</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="current-password"
          />
        </div>

        <button
          type="submit"
          className="login-button"
          disabled={loading}
        >
          {loading ? 'Ingresando…' : 'Ingresar'}
        </button>

        {/* Optional: Add links for password reset */}
        {/* <div className="login-links">
          <a href="/forgot-password">Forgot Password?</a>
        </div> */}
      </form>

      <div className="login-theme-toggle">
        <NightModeToggle />
      </div>
    </div>
  );
};

export default Login;